let instance = null;

class PrequalState {
	constructor() {
		if (!instance) {
			this._isPrequalShown = true;
			this._noPrequal = false;

			instance = this;
		}

		return instance;
	}

	static get PARAM_REDIRECT_SOURCE_PAGE() {
		return 'rsp';
	}

	/**
	 * @return {PrequalState}
	 */
	static getInstance() {
		if (!PrequalState._instance) {
			PrequalState._instance = new PrequalState()
		}

		return PrequalState._instance;
	}

	get isPrequalShown() {
		return this._isPrequalShown;
	}

	set isPrequalShown(value) {
		this._isPrequalShown = value;
	}

	get noPrequal() {
		return this._noPrequal;
	}

	set noPrequal(value) {
		this._noPrequal = value;
	}
}

export default PrequalState;
